import { Grid, CircularProgress, Box, Typography } from '@mui/material'
import ROUTE from 'constant/route'
import { useState, useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { logout } from 'store/actions/auth.action'
export const useLogout = () => {
    const history = useHistory()
    const handleOnLogout = useCallback(async () => {
        history.replace(ROUTE.LOGOUT)
    }, [history])
    return {
        handleOnLogout,
    }
}
function LogoutPage() {
    const dispatch = useDispatch()
    const history = useHistory()
    const [height, setHeight] = useState(0)
    const onResize = useCallback(() => {
        setHeight(window.innerHeight)
    }, [])

    useEffect(() => {
        setHeight(window.innerHeight)
        window.addEventListener('resize', onResize)

        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [height, onResize])

    useEffect(() => {
        logout()(dispatch).then(() => {
            history.replace(ROUTE.LOGIN)
        })
    }, [dispatch, history])

    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            justifySelf="center"
            style={{
                height,
                display: height === 0 ? 'none' : undefined,
            }}
        >
            <CircularProgress size={60} />
            <Box mt={2}>
                <Typography variant="h5">Logging out....</Typography>
            </Box>
        </Grid>
    )
}

export default LogoutPage
